import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { EventType, PublicClientApplication } from '@azure/msal-browser'

import { AzureAdContext } from './AzureAdContext'
import { ReactAdProviderProps } from './types'

export const AzureAdProvider: React.FC<ReactAdProviderProps> = (props) => {
  const [msalInstance, setMsalInstance] = useState<PublicClientApplication | null>(null)

  useEffect(() => {
    if (!props.config) {
      throw new Error('configuration is missed in AzureAdProvider')
    }

    const instance = new PublicClientApplication(props.config)

    instance.initialize().then(() => {
      instance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS) {
          console.log('Login Success')
        }
      })

      setMsalInstance(instance)
    })
  }, [props.config])

  if (!msalInstance) {
    return (
      <div className='min-h-screen grid place-items-center'>
        <Button variant='ghost' disabled>
          <Spinner data-icon='inline-start' />
          Initializing BackOffice for you!
        </Button>
      </div>
    )
  }

  return <AzureAdContext.Provider value={msalInstance}>{props.children}</AzureAdContext.Provider>
}
